module.exports = __webpack_public_path__ + "img/ico-pay-bigamount.f66c13ab.png";